module.exports = __webpack_public_path__ + "media/images/logo_en-0265343f4ca7d37b033f543c8333e2d9.svg";